
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/simulacao",
      function () {
        return require("private-next-pages/simulacao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/simulacao"])
      });
    }
  